export enum PeriodType {
  Monthly = "Monthly",
  SemiAnnual = "SemiAnnual",
  Annual = "Annual",
}
  